<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="['cortex-icon', cssClass]"
    aria-hidden="true"
  >
    <!--
      Kortex mark — "Neural Synapse"
      Three outer synapse nodes connected through a central nucleus
      via organic curved dendrites. Inspired by the actual neuron structure.
    -->

    <!-- ── Outer ring (faint boundary, optional depth) ── -->
    <circle cx="12" cy="12" r="10.5" stroke="currentColor" stroke-width="0.6" opacity="0.18"/>

    <!-- ── Outer node: top ── -->
    <circle cx="12" cy="4" r="1.8" fill="currentColor"/>

    <!-- ── Outer node: bottom-left ── -->
    <circle cx="4.5" cy="18" r="1.8" fill="currentColor"/>

    <!-- ── Outer node: bottom-right ── -->
    <circle cx="19.5" cy="18" r="1.8" fill="currentColor"/>

    <!-- ── Central nucleus ── -->
    <circle cx="12" cy="12.5" r="2.4" fill="currentColor"/>

    <!-- ── Dendrite: nucleus → top node (organic S-curve) ── -->
    <path
      d="M11.3 10.2 C10.8 8.2 11.2 6.3 12 5.8"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />

    <!-- ── Dendrite: nucleus → bottom-left node ── -->
    <path
      d="M10.3 14.2 C8.5 15.6 6.3 16.8 6 16.5"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />

    <!-- ── Dendrite: nucleus → bottom-right node ── -->
    <path
      d="M13.7 14.2 C15.5 15.6 17.7 16.8 18 16.5"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />

    <!-- ── Outer arcs connecting nodes (axon collaterals, subtle) ── -->
    <path
      d="M13.5 4.8 C17.2 7.5 20 12.5 19 16.5"
      stroke="currentColor"
      stroke-width="0.9"
      stroke-linecap="round"
      opacity="0.28"
    />
    <path
      d="M10.5 4.8 C6.8 7.5 4 12.5 5 16.5"
      stroke="currentColor"
      stroke-width="0.9"
      stroke-linecap="round"
      opacity="0.28"
    />
    <path
      d="M5.8 19.2 C8.2 21 15.8 21 18.2 19.2"
      stroke="currentColor"
      stroke-width="0.9"
      stroke-linecap="round"
      opacity="0.28"
    />
  </svg>
</template>

<script>
export default {
  name: 'CortexIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16
    },
    cssClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.cortex-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
